module.exports = __webpack_public_path__ + "static/map-mobile.5c6f8081.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/map-mobile.png
// module id = 944
// module chunks = 35783957827783